(function () {
    window.NewsGraph = window.NewsGraph || {};

    class NewsGraph2DControls {
        constructor(container, pivot, camera) {
            this.container = container;
            this.pivot = pivot;
            this.camera = camera;

            this.panX = 0;
            this.panY = 0;
            this.autoRotate = true;

            const overlay = document.createElement('div');
            overlay.style.cssText = 'position:absolute;inset:0;z-index:5;cursor:grab;';
            this.container.appendChild(overlay);
            this.overlay = overlay;

            const DRAG_THRESHOLD = 5;
            const drag = {
                active: false,
                x: 0,
                y: 0,
                startX: 0,
                startY: 0,
                isDragging: false
            };
            this.drag = drag;

            this._onContextMenu = e => e.preventDefault();
            this._onMouseDown = e => {
                e.preventDefault();
                if (e.button === 2) {
                    drag.active = true;
                    drag.x = e.clientX;
                    drag.y = e.clientY;
                    drag.startX = e.clientX;
                    drag.startY = e.clientY;
                    drag.isDragging = false;
                    this.overlay.style.cursor = 'grabbing';
                } else if (e.button === 0) {
                    drag.clickActive = true;
                    drag.startX = e.clientX;
                    drag.startY = e.clientY;
                    drag.isDragging = false;
                }
            };

            this._onMouseUp = (e) => {
                this.overlay.style.cursor = 'grab';
                if (drag.clickActive && !drag.isDragging && this.onClick) {
                    this.onClick(e.clientX, e.clientY);
                }
                drag.active = false;
                drag.clickActive = false;
                drag.isDragging = false;
            };

            this._onMouseMove = e => {
                if (!drag.active) {
                    if (drag.clickActive) {
                        const dist = Math.hypot(e.clientX - drag.startX, e.clientY - drag.startY);
                        if (dist > DRAG_THRESHOLD) {
                            drag.isDragging = true;
                        }
                    }
                    return;
                }

                if (!drag.isDragging) {
                    const dist = Math.hypot(e.clientX - drag.startX, e.clientY - drag.startY);
                    if (dist > DRAG_THRESHOLD) {
                        drag.isDragging = true;
                    } else {
                        return;
                    }
                }

                const dx = e.clientX - drag.x;
                const dy = e.clientY - drag.y;
                const speed = this.camera.position.z / 400;
                this.panX += dx * speed;
                this.panY -= dy * speed;

                drag.x = e.clientX;
                drag.y = e.clientY;
            };

            this._onWheel = e => {
                e.preventDefault();
                this.camera.position.z = Math.max(1.0, Math.min(250,
                    this.camera.position.z + e.deltaY * 0.04
                ));
            };

            this._onTouchStart = e => {
                if (e.touches.length !== 1) return;
                const touch = e.touches[0];
                drag.active = true;
                drag.x = touch.clientX;
                drag.y = touch.clientY;
                drag.startX = touch.clientX;
                drag.startY = touch.clientY;
                drag.isDragging = false;
            };

            this._onTouchMove = e => {
                if (!drag.active || e.touches.length !== 1) return;
                const touch = e.touches[0];
                const clientX = touch.clientX;
                const clientY = touch.clientY;

                if (!drag.isDragging) {
                    const dist = Math.hypot(clientX - drag.startX, clientY - drag.startY);
                    if (dist > DRAG_THRESHOLD) {
                        drag.isDragging = true;
                    } else {
                        return;
                    }
                }

                e.preventDefault();

                const dx = clientX - drag.x;
                const dy = clientY - drag.y;
                const speed = this.camera.position.z / 400;
                this.panX += dx * speed;
                this.panY -= dy * speed;

                drag.x = clientX;
                drag.y = clientY;
            };

            this._onTouchEnd = e => {
                if (drag.active && !drag.isDragging && this.onClick) {
                    this.onClick(drag.startX, drag.startY);
                }
                drag.active = false;
                drag.isDragging = false;
            };

            overlay.addEventListener('contextmenu', this._onContextMenu);
            overlay.addEventListener('mousedown', this._onMouseDown);
            overlay.addEventListener('wheel', this._onWheel, { passive: false });
            overlay.addEventListener('touchstart', this._onTouchStart, { passive: true });
            overlay.addEventListener('touchmove', this._onTouchMove, { passive: false });
            overlay.addEventListener('touchend', this._onTouchEnd, { passive: true });
            window.addEventListener('mouseup',   this._onMouseUp);
            window.addEventListener('mousemove', this._onMouseMove);
        }

        update() {
            this.pivot.position.set(this.panX, this.panY, 0);
        }

        enableAutoRotate() {
            this.autoRotate = true;
            if (this.onAutoRotateChange) this.onAutoRotateChange(true);
        }

        disableAutoRotate() {
            this.autoRotate = false;
            if (this.onAutoRotateChange) this.onAutoRotateChange(false);
        }

        destroy() {
            window.removeEventListener('mouseup',   this._onMouseUp);
            window.removeEventListener('mousemove', this._onMouseMove);
            this.overlay?.removeEventListener('touchstart', this._onTouchStart);
            this.overlay?.removeEventListener('touchmove', this._onTouchMove);
            this.overlay?.removeEventListener('touchend', this._onTouchEnd);
            this.overlay?.remove();
        }
    }

    window.NewsGraph.NewsGraph2DControls = NewsGraph2DControls;
})();
